import ButtonNeu from "../../interface/ButtonNeu";
import Modal from "../../interface/Modal";
import CreateEditUserForm from "../authentication/CreateEditUserForm";
import ImageEdit from "../authentication/ImageEdit";

function Administration() {
  return (
    <div>
      <Modal>
        <Modal.Open opens="createuser">
          <ButtonNeu>ADD / EDIT USER</ButtonNeu>
        </Modal.Open>
        <Modal.Window name="createuser">
          {/* <CreateEditUserForm /> */}
          <ImageEdit />
        </Modal.Window>
      </Modal>
    </div>
  );
}

export default Administration;
